export enum Type {
  OPEN_CONTEXT_MENU = "TOGGLE_CONTEXT_MENU",
  CLOSE_CONTEXT_MENU = "CLOSE_CONTEXT_MENU",
}

interface IOpenContextMenu {
  type: Type.OPEN_CONTEXT_MENU;
  mosaicId: string;
}

interface ICloseContextMenu {
  type: Type.CLOSE_CONTEXT_MENU;
  mosaicId: string;
}

export type Action = IOpenContextMenu | ICloseContextMenu;

/**
 * Toggle a context menu within a mosaic.
 * @param id - ID of the Mosaic the ContextMenu belongs to
 */
export const openContextMenu = (id: string): IOpenContextMenu => ({
  type: Type.OPEN_CONTEXT_MENU,
  mosaicId: id,
});

// export const createContextMenu = (
//   id: string
// ): ThunkAction<Promise<void>, IRootState, {}, AnyAction> => {
//   return async (
//     dispatch: ThunkDispatch<{}, {}, AnyAction>,
//     getState: () => IRootState
//   ): Promise<void> => {
//     dispatch({ type: Type.CREATE_CONTEXT_MENU, mosaicId: id });
//   };
// };

export const closeContextMenu = (id: string): ICloseContextMenu => ({
  type: Type.CLOSE_CONTEXT_MENU,
  mosaicId: id,
});
